import Vue from "vue";
import { toolbarActionsMutations } from "../mutation-types";

export default {
	namespaced: true,

	state: {
		items: []
	},

	actions: {
		add( { commit }, items ) {
			[].concat( items || [] ).forEach( item => commit( toolbarActionsMutations.ADD, item ) );
		},

		clear( { commit } ) {
			commit( toolbarActionsMutations.CLEAR );
		},

		remove( { commit, dispatch }, items ) {

			// Check this way because item may simply be a falsy index (0)
			if ( typeof items !== "undefined" && items !== null ) {
				[].concat( items ).forEach( item => {
					const itemType = typeof item;

					if ( itemType === "number" ) {
						commit( toolbarActionsMutations.REMOVE, item );
					} else if ( itemType === "text" ) {
						dispatch( "removeByText", item );
					} else if ( itemType === "object" && item.hasOwnProperty( "text" ) ) {
						dispatch( "removeByText", item.text );
					}
				} );
			}
		},

		removeByText( { dispatch, state }, text ) {
			const removeIndex = state.items.findIndex( action => action.text === text );

			if ( removeIndex !== -1 ) {
				dispatch( "remove", removeIndex );
			}
		}
	},

	mutations: {
		[toolbarActionsMutations.ADD]( store, item ) {
			store.items.push( item );
		},

		[toolbarActionsMutations.CLEAR]( store ) {
			Vue.set( store, "items", [] );
		},

		[toolbarActionsMutations.REMOVE]( store, itemIndex ) {
			Vue.delete( store.items, itemIndex );
		}
	}
};
